import React from 'react';
export const mailFolderListItems = (
  <div>
  </div>
);

export const otherMailFolderListItems = (
  <div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/leftnav/index.js